import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import i18n from './i18n'
// 개발의 용의성을 위해 권한 부분은 해제 한 상태
// import './auth'
// library import
import JSZip from 'jszip'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import solidGauge from 'highcharts/modules/solid-gauge'
import jquery from 'jquery'
import lodash from 'lodash'
import dayjs from 'dayjs'
import directives from '@/directives'
import vuescroll from 'vuescroll/dist/vuescroll-native'
import 'vuescroll/dist/vuescroll.css'
import SimpleVueValidation from 'simple-vue-validator'
// 로그 & 에러 관리
import logger from '@/utils/log'
// 터치원 콜백 함수
import touchOneCallbackFn from '@/utils/touchOne'
import { getAgent, getAgentType } from '@/utils/check'
import naver from 'vue-naver-maps'
import Message from '@/utils/message'
import { confirmIfExit } from '@/api/greenCommon/confirmIfExit'
require('vue2-animate/dist/vue2-animate.min.css')

// ****************** Highchart 설정 ********************************
// highchart의 특정 chart type들을 사용하기 위한 higtchartsMore 추가
HighchartsMore(Highcharts)
// highchart의 solidgauge 타입을 사용하기 위한 설정
// highchart-more와 함께 import 해줘야 solidgauge type 사용 가능
solidGauge(Highcharts)
// *****************************************************************
// jszip 전역 설정
window.JSZip = JSZip
// Validation 처리를 위한 전용 라이브러리 전역 설정
const Validator = SimpleVueValidation.Validator
window.Validator = Validator
// jquery 호환 라이브러리를 위한 전역 설정
window.$ = window.jQuery = window.jquery = jquery
// Lodash window 전역 설정
window._ = lodash
Vue.prototype['$time'] = dayjs

// 터치원 객체를 생성한다.
const touchOneObj = new mfnpObj()
window.touchOneObj = touchOneObj
window.cbGetReturnValInTouchOne = touchOneCallbackFn

// tui 기반 제품들에서 GA로 상태 정보 넘기는 부분을 해제
tui.usageStatistics = false

let agent = getAgentType()
let mobileType = getAgent()

if (agent === 'HybridWeb' && mobileType === 'Android') {
  $.getScript('/cordova/cordova.js', function() {
    $.getScript('/cordova/cordova_android.js', function() {
      document.addEventListener('deviceready', function() {
        document.addEventListener('backbutton', function(e) {
          if (
            window.location.href.toLocaleLowerCase().indexOf('personalmonitoring') > -1 ||
            window.location.href.toLocaleLowerCase().indexOf('centeras') > -1 ||
            window.location.href.toLocaleLowerCase().indexOf('constructor') > -1
          ) {
            e.preventDefault()
            if (confirm('앱을 종료 하시겠습니까?')) {
              navigator.app.exitApp()
            }
          } else {
            navigator.app.backHistory()
          }
        }, false)
      }, false)
    })
  })
}

// 사용자 Event에 따른 Log & Error 처리 로직을 실행한다.
logger.init(Vue)

Vue.use(HighchartsVue, { Highcharts })
Vue.use(vuescroll)
Vue.use(directives)
Vue.use(SimpleVueValidation)

Vue.use(naver, {
  // clientID : 'EjIfuMMC0tMpoPsrYPJRpcHPtewBWZk7CSSPYKg7',
  clientID: 'qqertwhha8', //hs3.hyundai-es.co.kr
  useOpenAPI: false,
  subModules: 'geocoder'
})

Vue.config.productionTip = false

let _mainVue = new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

window._app = _mainVue
